import React, { useState } from 'react'
import ReactPlayer from 'react-player'
import { Fade } from "react-awesome-reveal";
import ModalVideo from 'react-modal-video'
/* eslint-disable no-unused-vars */

const VideoService = () => {
    const [isOpen, setOpen] = useState(false)

    return (
        <section id="funfact" className="video-section-modern">
            {/* Decorative shapes */}
            <div className="decorative-shape decorative-shape-1"></div>
            <div className="decorative-shape decorative-shape-2"></div>

            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                {/* Section Header */}
                <div className="section-header-modern">
                    <Fade direction="down" triggerOnce={true} duration={800}>
                        <span className="section-badge">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <polygon points="5,3 19,12 5,21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            How It Works
                        </span>
                    </Fade>
                    <Fade direction="down" triggerOnce={true} duration={1000} delay={100}>
                        <h2 className="section-title">See SAAS Watch in Action</h2>
                    </Fade>
                    <Fade direction="down" triggerOnce={true} duration={1000} delay={200}>
                        <p className="section-subtitle">
                            Watch how easy it is to manage your subscriptions and gain visibility into your SaaS spending.
                        </p>
                    </Fade>
                </div>

                {/* Video Wrapper */}
                <Fade direction="up" triggerOnce={true} duration={1200} delay={300}>
                    <div className="video-wrapper-modern" style={{ maxWidth: '900px', margin: '0 auto' }}>
                        <div style={{
                            position: 'relative',
                            paddingTop: '56.25%',
                            borderRadius: '24px',
                            overflow: 'hidden',
                            boxShadow: '0 30px 80px rgba(0, 0, 0, 0.15)'
                        }}>
                            <iframe
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    border: 'none'
                                }}
                                src="https://www.youtube.com/embed/n-VL9_0INMM"
                                title="SAAS Watch Demo"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </Fade>
            </div>

            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="n-VL9_0INMM" onClose={() => setOpen(false)} />
        </section>
    )
}

export default VideoService;
